import type { LlmRole } from "@school-sales-ai/shared";

/**
 * Who said it, as the CRM labels them.
 *
 * Shared by the conversation timeline (both the desktop and the mobile one) and
 * the Buzón rows so no two surfaces can disagree about what to call the same
 * message — the mistake `time-ago.ts` documents having already been made once in
 * this app, and one the mobile timeline was making until it started calling this.
 *
 * Takes only the role: every surface that renders a label renders a channel chip
 * or icon beside it, so spelling the channel into the label duplicated it. The
 * assistant used to be "Bot Web" / "Bot WhatsApp" for that reason.
 *
 * "Asesor", not "Agente": it is the word this product already uses everywhere
 * else — the prompts, the digest and the email templates all say asesor — and it
 * is what the AI itself promises the prospect. The sparkle is what separates the
 * two agent labels at a glance in a dense list.
 */
export function senderLabel(role: LlmRole): string {
  if (role === "human_agent") return "Asesor";
  if (role === "assistant") return "Agente IA ✨";
  return "Prospecto";
}
